/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<template>
</template>
<script >
/**
 * ユーザーの管理画面 - 詳細画面データ作成コンポーネント
 * @vuedoc
 * @exports js/parts/user/funcDetail
 */
export default {
	mixins: [
		// 詳細画面パラメータの共通機能
		require('js/common/funcDetailBase2.mixin.vue'),
	],
	computed: {

		/**
		 * 削除ボタンの表示条件
		 */
		is_disp_delete_btn: function(){
			return this.r_settings.user.user_id == this.r_info.user_id ? false : true;
		},
	},
	methods: {
		/**
		 * 企業コードを表示データに詰め替え
		 * 
		 * @function convertInitCode
		 * 
		 * @param {object} info - 取得データ
		 * @returns 企業コード
		 */
		convertInitCode : function(info){
			if(info == null ||
				info.company_code == null)
			{
				return "";
			}
			return info.company_code + "";
		},
		/**
		 * ユーザーIDを表示データに詰め替え
		 * 
		 * @function convertInitCode2
		 * 
		 * @param {object} info - 取得データ
		 * @returns ユーザーID
		 */
		convertInitCode2 : function(info){
			if(info == null ||
				info.user_id == null)
			{
				return "";
			}
			return info.user_id + "";
		},

		/**
		 * データ送信 <br>
		 * ******* 内部処理 *******<br>
		 * 更新データの送信 <br>
		 *
		 * @function sendUpdate
		 * 
		 * @param {number} update_type - データ変更フラグ
		 * @param {object} info - 送信データ
		 * @returns 更新処理実行完了としてtrueを返す
		 */
		sendUpdate: function( update_type, info , extra ){
			var url = "api/user/update";
			var data ={};
			switch(update_type){
				case 1:
				case 0:
				default:
					$.extend( data, this.createUpdateRec(info) ,
						{ "company_code":Number(this.r_code), 
						  "update_timestamp": info.update_timestamp, 
						  "update_type": update_type,
						  "reg_restrict": 1							// 更新制限フラグ(ユーザーの一部のみユーザー変更権限がなくても更新できる)
						} );
					break;
				case 2:// 削除処理
					data = {"company_code":Number(this.r_code),"user_id":info.user_id,"update_timestamp": info.update_timestamp,"update_type": update_type};
					break;
			}

			var form = [];
			form.push(data);

			var target = this;
			var callbackOK = function(rResponse){
				if(rResponse.data && rResponse.data.result == 0) {
					console.log("update success : ");
					console.log(rResponse);
					target.$emit("event_update_end",0,update_type,rResponse, rResponse.data.errmessage);
				} else {
					console.log("update success error! :");
					console.log(rResponse);
					target.$emit("event_update_end",1,update_type,rResponse, rResponse.data.errmessage, rResponse.data.rec);	
				}
			}
			var callbackNG = function(rResponse){
				console.log("update success error! :");
				console.log(rResponse);
				target.$emit("event_update_end",1,update_type,rResponse, rResponse.data.errmessage, rResponse.data.rec);
			}
			this.manager.post(url,form,callbackOK,callbackNG);
			return true;
		},
		/**
		 * 送信データの作成
		 * 
		 * @function createUpdateRec
		 * 
		 * @param {object} info - 取得データ
		 * @returns 更新データ
		 */
		createUpdateRec: function(info){
			return {
				company_code:info.company_code,
				user_id: info.user_id,
				mail_address:info.mail_address,
				week_calendar_cl:info.week_calendar_cl,
				plu_display_type:info.plu_display_type,
				password:info.password,
			}
		},

		/**
		 * 初期データ用の変換データを取得
		 * パスワードのパラメータを追加
		 * 
		 * @function convertInitData
		 * 
		 * @param {object} info - 取得データ
		 * @returns パラメータ追加後データ
		 * 
		 */
		convertInitData: function(info){
			var data =  $.extend(true,{},info);
			this.$set(data,"password","");
			return data;
		},
		/**
		 * 更新リクエスト送信
		 * 
		 * @function sendRefresh
		 * 
		 * @param {integer} code 企業コード
		 * @param {String} code2 ユーザーID
		 * @returns 更新処理実行完了結果
		 */
		sendRefresh: function(code , code2){
			var url = "api/user/search-next";
			var data = {
				"company_code":Number(code),
				"direction":0,
				"call_code":code2,
			};
				
			var target = this;
			var callbackOK = function(rResponse){
				console.log("update success : ");
				console.log(rResponse);
				if(rResponse.data && rResponse.data.result == 0) {
					target.$emit("event_refresh_end",0, rResponse.data.rec['0']);
				} else {
					target.$emit("event_refresh_end",1, rResponse, rResponse.data.errmessage);
				}
			}
			var callbackNG = function(rResponse){
				console.log("refresh success error! :");
				console.log(rResponse);
				target.$emit("event_refresh_end",1, rResponse, rResponse.data.errmessage);
			}
			this.manager.access2(url,data,callbackOK,callbackNG);
			return true;
		},
		/**
		 * コードのチェック
		 */
		checkCode: function(){
			this.m_bCodeEnable = true;
		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts/user/header/funcDetail.vue